/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ meta: NonNullable<unknown> }} Search_History_AbandonedInputs */

const en_us2_search_history_abandoned = /** @type {(inputs: Search_History_AbandonedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.meta} · abandoned`)
};

const pt_br2_search_history_abandoned = /** @type {(inputs: Search_History_AbandonedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.meta} · abandonado`)
};

const es_419_search_history_abandoned = /** @type {(inputs: Search_History_AbandonedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.meta} · abandonado`)
};

const pt_pt2_search_history_abandoned = /** @type {(inputs: Search_History_AbandonedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.meta} · abandonado`)
};

const fr_fr2_search_history_abandoned = /** @type {(inputs: Search_History_AbandonedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.meta} · abandonnée`)
};

const de_de2_search_history_abandoned = /** @type {(inputs: Search_History_AbandonedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.meta} · abgebrochen`)
};

const it_it2_search_history_abandoned = /** @type {(inputs: Search_History_AbandonedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.meta} · abbandonato`)
};

/**
* | output |
* | --- |
* | "{meta} · abandoned" |
*
* @param {Search_History_AbandonedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_history_abandoned = /** @type {((inputs: Search_History_AbandonedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_History_AbandonedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_history_abandoned(inputs)
	if (locale === "es-419") return es_419_search_history_abandoned(inputs)
	if (locale === "pt-PT") return pt_pt2_search_history_abandoned(inputs)
	if (locale === "fr-FR") return fr_fr2_search_history_abandoned(inputs)
	if (locale === "de-DE") return de_de2_search_history_abandoned(inputs)
	if (locale === "it-IT") return it_it2_search_history_abandoned(inputs)
	return en_us2_search_history_abandoned(inputs)
});
export { search_history_abandoned as "search.history_abandoned" }